/**
 * PerplayAdminApi
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';

/**
 * The CampaignControllerDtoCampaignTerminateRequest model module.
 * @module model/CampaignControllerDtoCampaignTerminateRequest
 * @version 1.0
 */
class CampaignControllerDtoCampaignTerminateRequest {
    /**
     * Constructs a new <code>CampaignControllerDtoCampaignTerminateRequest</code>.
     * @alias module:model/CampaignControllerDtoCampaignTerminateRequest
     * @param campaignNo {Number} 
     */
    constructor(campaignNo) { 
        
        CampaignControllerDtoCampaignTerminateRequest.initialize(this, campaignNo);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj, campaignNo) { 
        obj['campaignNo'] = campaignNo;
    }

    /**
     * Constructs a <code>CampaignControllerDtoCampaignTerminateRequest</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/CampaignControllerDtoCampaignTerminateRequest} obj Optional instance to populate.
     * @return {module:model/CampaignControllerDtoCampaignTerminateRequest} The populated <code>CampaignControllerDtoCampaignTerminateRequest</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new CampaignControllerDtoCampaignTerminateRequest();

            if (data.hasOwnProperty('campaignNo')) {
                obj['campaignNo'] = ApiClient.convertToType(data['campaignNo'], 'Number');
            }
        }
        return obj;
    }

    /**
     * Validates the JSON data with respect to <code>CampaignControllerDtoCampaignTerminateRequest</code>.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @return {boolean} to indicate whether the JSON data is valid with respect to <code>CampaignControllerDtoCampaignTerminateRequest</code>.
     */
    static validateJSON(data) {
        // check to make sure all required properties are present in the JSON string
        for (const property of CampaignControllerDtoCampaignTerminateRequest.RequiredProperties) {
            if (!data[property]) {
                throw new Error("The required field `" + property + "` is not found in the JSON data: " + JSON.stringify(data));
            }
        }

        return true;
    }


}

CampaignControllerDtoCampaignTerminateRequest.RequiredProperties = ["campaignNo"];

/**
 * @member {Number} campaignNo
 */
CampaignControllerDtoCampaignTerminateRequest.prototype['campaignNo'] = undefined;






export default CampaignControllerDtoCampaignTerminateRequest;

